module.exports = __webpack_public_path__ + "img/ASC_SORT.88930516.svg";